import MyModal from "./MyModal"
const MyDialog = {
  show({ title = "", msg = "", onClickOK = (cModal: any) => {} } = {}) {
    MyModal.showMyDialogWithConfigModal({
      title: title,
      component: msg,
      modalCentered: true,
      size: "md",
      showFooter: true,
      showFooterOK: true,
      backdrop: "static",
      onClickOK: cModal => {
        if (onClickOK) {
          onClickOK(cModal)
        }
        if (cModal.hide) {
          cModal.hide()
        }
      },
    })
  },
  showConfirm({
    title = "",
    msg = "",
    isHTML = false,
    onClickOK = (cModal: any) => {},
  } = {}) {
    MyModal.showMyDialogWithConfigModal({
      title: title,
      component: msg,
      modalCentered: true,
      size: "md",
      showFooter: true,
      showFooterOK: true,
      showFooterClose: true,
      backdrop: "static",
      morePropsModal: {
        zIndex: 1080, //bổ sung zIndex 1080 cho confirm để cao hơn popover, tooltip
      },
      onClickOK: cModal => {
        if (onClickOK) {
          onClickOK(cModal)
        }
        if (cModal.hide) {
          cModal.hide()
        }
      },
      ...(isHTML === true
        ? {
            component: null,
            msgHtml: msg,
          }
        : {}),
    })
  },
}

export default MyDialog
